var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad" },
    [
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|cpf", name: _vm.nomeAba + "/CPF" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "CPF:" } }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "CPF" },
                          model: {
                            value: _vm.pessoaFisica.cpf,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "cpf", $$v)
                            },
                            expression: "pessoaFisica.cpf"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: _vm.nomeAba + "/Nome" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Nome:" } }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "Nome", maxlength: "300" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "pessoaFisica",
                                "nome"
                              )
                            }
                          },
                          model: {
                            value: _vm.pessoaFisica.nome,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "nome", $$v)
                            },
                            expression: "pessoaFisica.nome"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.requiredRg.rules,
                  name: _vm.nomeAba + "/RG"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "RG:",
                            required: _vm.requiredRg.label
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "RG", maxlength: "30" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "pessoaFisica",
                                "rg"
                              )
                            }
                          },
                          model: {
                            value: _vm.pessoaFisica.rg,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "rg", $$v)
                            },
                            expression: "pessoaFisica.rg"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.isProcessoFisico
        ? _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: { name: _vm.nomeAba + "/Tipo de documento" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Tipo de documento:",
                                  required: false
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Tipo de documento",
                                    "value-key": "codigo",
                                    "no-match-text":
                                      "Nenhum tipo de documento encontrado",
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable"
                                  },
                                  model: {
                                    value: _vm.pessoaFisica.tipoDocumento,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoaFisica,
                                        "tipoDocumento",
                                        $$v
                                      )
                                    },
                                    expression: "pessoaFisica.tipoDocumento"
                                  }
                                },
                                _vm._l(_vm.tipoDocumentos, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: { label: item, value: item }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      925996746
                    )
                  })
                ],
                1
              ),
              _vm.pessoaFisica.tipoDocumento == "OUTROS"
                ? _c(
                    "el-col",
                    { staticClass: "inputDiv", attrs: { span: 8 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: _vm.nomeAba + "/OutrosTipoDocumento"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Outros:", required: true }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    attrs: { name: "Outros", maxlength: "30" },
                                    on: {
                                      input: function($event) {
                                        return _vm.toUppercase(
                                          $event,
                                          "pessoaFisica",
                                          "outrosTipoDocumento"
                                        )
                                      }
                                    },
                                    model: {
                                      value:
                                        _vm.pessoaFisica.outrosTipoDocumento,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.pessoaFisica,
                                          "outrosTipoDocumento",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "pessoaFisica.outrosTipoDocumento"
                                    }
                                  }),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1326405023
                        )
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.requiredRg.rules,
                  name: _vm.nomeAba + "/Órgão Expedidor",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Órgão expedidor:",
                            required: _vm.requiredRg.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Órgão expedidor",
                              "no-match-text": "Nenhum orgão encontrado",
                              placeholder: "Selecione",
                              "value-key": "id",
                              filterable: "filterable",
                              clearable: "clearable"
                            },
                            model: {
                              value: _vm.pessoaFisica.orgaoExpedidor.nome,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoaFisica.orgaoExpedidor,
                                  "nome",
                                  $$v
                                )
                              },
                              expression: "pessoaFisica.orgaoExpedidor.nome"
                            }
                          },
                          _vm._l(_vm.orgaosExpedidores, function(
                            orgaoExpedidor
                          ) {
                            return _c("el-option", {
                              key: orgaoExpedidor.id,
                              attrs: {
                                label: orgaoExpedidor.nome,
                                value: orgaoExpedidor.nome
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.requiredRg.rules,
                  name: _vm.nomeAba + "/UF do RG",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "UF do RG:",
                            required: _vm.requiredRg.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "UF do RG",
                              "no-match-text": "Nenhuma UF encontrada",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable",
                              disabled: !_vm.pessoaFisica.orgaoExpedidor.nome
                            },
                            on: { change: _vm.setOrgaoCodigo },
                            model: {
                              value: _vm.pessoaFisica.orgaoExpedidor.estado,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoaFisica.orgaoExpedidor,
                                  "estado",
                                  $$v
                                )
                              },
                              expression: "pessoaFisica.orgaoExpedidor.estado"
                            }
                          },
                          _vm._l(_vm.estadosBr, function(estado) {
                            return _c("el-option", {
                              key: estado.codigo,
                              attrs: {
                                label: estado.nome,
                                value: estado.codigo
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          !_vm.isBeneficiarioTeq
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("app-input-telefone", {
                    attrs: {
                      telefones: _vm.pessoa.telefones,
                      nomeAba: _vm.nomeAba,
                      requiredTelefones: !_vm.isProcessoFisico,
                      observer: _vm.observer
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.isLiberacao && !_vm.isProcessoFisico
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: _vm.required.rules,
                      name: _vm.nomeAba + "/Nome da Mãe",
                      mode: "lazy"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: {
                                  label: "Nome da Mãe:",
                                  required: _vm.required.label
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  type: "text",
                                  maxlength: "300",
                                  name: "nomeDaMae"
                                },
                                model: {
                                  value: _vm.pessoaFisica.nomeDaMae,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pessoaFisica, "nomeDaMae", $$v)
                                  },
                                  expression: "pessoaFisica.nomeDaMae"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2814578398
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Nacionalidade",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", { attrs: { label: "Nacionalidade:" } }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Nacionalidade",
                              "no-match-text":
                                "Nenhuma nacionalidade encontrada",
                              placeholder: "Selecione",
                              "value-key": "id",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            on: { change: _vm.changeNacionalidade },
                            model: {
                              value: _vm.pessoaFisica.nacionalidade,
                              callback: function($$v) {
                                _vm.$set(_vm.pessoaFisica, "nacionalidade", $$v)
                              },
                              expression: "pessoaFisica.nacionalidade"
                            }
                          },
                          _vm._l(_vm.gentilico, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              staticClass: "selectNacionalidade",
                              attrs: {
                                label: item.gentilico + " - " + item.nomePais,
                                value: item.sigla
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.ufAndMunicipioRequired(),
                  name: _vm.nomeAba + "/UF de Naturalidade",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "UF de naturalidade:",
                            required:
                              !_vm.isProcessoFisico &&
                              _vm.isBrasileiro &&
                              _vm.required.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              "no-match-text": "Nenhuma UF encontrada",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable",
                              disabled: !_vm.isBrasileiro,
                              name: "UF de naturalidade"
                            },
                            on: { change: _vm.setMunicipioUf },
                            model: {
                              value: _vm.pessoaFisica.ufNaturalidade,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoaFisica,
                                  "ufNaturalidade",
                                  $$v
                                )
                              },
                              expression: "pessoaFisica.ufNaturalidade"
                            }
                          },
                          _vm._l(_vm.estadosBr, function(item) {
                            return _c("el-option", {
                              key: item.codigo,
                              attrs: { label: item.nome, value: item.codigo }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.ufAndMunicipioRequired(),
                  name: _vm.nomeAba + "/Município de Naturalidade",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Município de naturalidade:",
                            required:
                              !_vm.isProcessoFisico &&
                              _vm.isBrasileiro &&
                              _vm.required.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Município de Naturalidade",
                              "no-match-text": "Nenhum município encontrado",
                              placeholder: "Selecione",
                              filterable: "filterable",
                              disabled: !_vm.pessoaFisica.ufNaturalidade,
                              "value-key": "id"
                            },
                            model: {
                              value: _vm.pessoaFisica.naturalidade,
                              callback: function($$v) {
                                _vm.$set(_vm.pessoaFisica, "naturalidade", $$v)
                              },
                              expression: "pessoaFisica.naturalidade"
                            }
                          },
                          _vm._l(_vm.municipios, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.nome, value: item }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: !_vm.isProcessoFisico ? _vm.required.rules : "",
                  name: _vm.nomeAba + "/Data de nascimento"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Data de nascimento:",
                            required:
                              _vm.required.label && !_vm.isProcessoFisico
                          }
                        }),
                        _c("el-date-picker", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##/##/#####",
                              expression: "'##/##/#####'"
                            }
                          ],
                          staticClass: "input full-width",
                          class: { erro: errors.length },
                          attrs: {
                            type: "date",
                            name: "Data de nascimento",
                            placeholder: "Selecione",
                            format: "dd/MM/yyyy",
                            "picker-options": _vm.pickerOptions
                          },
                          model: {
                            value: _vm.pessoaFisica.dataNascimento,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaFisica, "dataNascimento", $$v)
                            },
                            expression: "pessoaFisica.dataNascimento"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.required.rules,
                  name: _vm.nomeAba + "/Estado civil"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Estado civil:",
                            required: _vm.required.label
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Estado civil",
                              "value-key": "codigo",
                              "no-match-text": "Nenhum estado civil encontrado",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            model: {
                              value: _vm.pessoaFisica.estadoCivil,
                              callback: function($$v) {
                                _vm.$set(_vm.pessoaFisica, "estadoCivil", $$v)
                              },
                              expression: "pessoaFisica.estadoCivil"
                            }
                          },
                          _vm._l(_vm.estadosCivil, function(item) {
                            return _c("el-option", {
                              key: item.codigo,
                              attrs: { label: item.nome, value: item.codigo }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          !_vm.isBeneficiarioTeq && !_vm.isProcessoFisico
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required|email",
                      name: _vm.nomeAba + "/E-mail"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", { attrs: { label: "E-mail:" } }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  name: "E-mail",
                                  maxlength: "100",
                                  label: "email"
                                },
                                model: {
                                  value: _vm.pessoa.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pessoa, "email", $$v)
                                  },
                                  expression: "pessoa.email"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      103685361
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isBeneficiarioTeq
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "",
                      name: _vm.nomeAba + "/Apelido",
                      mode: "lazy"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Apelido:", required: false }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: {
                                  type: "text",
                                  maxlength: "300",
                                  name: "apelido"
                                },
                                model: {
                                  value: _vm.pessoaFisica.apelido,
                                  callback: function($$v) {
                                    _vm.$set(_vm.pessoaFisica, "apelido", $$v)
                                  },
                                  expression: "pessoaFisica.apelido"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1608443807
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 30 } },
        [
          _vm.isLiberacao
            ? _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: "required",
                      name: _vm.nomeAba + "/Profissão"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Profissão:" }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticClass: "input select",
                                  class: { erro: errors.length },
                                  attrs: {
                                    name: "Profissão",
                                    "value-key": "codigo",
                                    "no-match-text":
                                      "Nenhuma profissão encontrada",
                                    placeholder: "Selecione",
                                    clearable: "clearable",
                                    filterable: "filterable"
                                  },
                                  model: {
                                    value: _vm.pessoaFisica.profissao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoaFisica,
                                        "profissao",
                                        $$v
                                      )
                                    },
                                    expression: "pessoaFisica.profissao"
                                  }
                                },
                                _vm._l(_vm.profissoes, function(item) {
                                  return _c("el-option", {
                                    key: item.codigo,
                                    attrs: {
                                      label: item.nome,
                                      value: item.codigo
                                    }
                                  })
                                }),
                                1
                              ),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4175467504
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.hasConjuge
            ? _c("app-dados-conjuge", {
                staticClass: "conjuge",
                attrs: {
                  pessoa: _vm.conjuge.pessoaFisica,
                  isViuvo: _vm.pessoaFisica.estadoCivil === "VIUVO",
                  nomeAba: _vm.nomeAba || "Interessado",
                  isProcessoFisico: _vm.isProcessoFisico,
                  estadoCivil: this.pessoa.pessoaFisica.estadoCivil
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22eb2a3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22eb2a3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPessoaFisica.vue
// module id = null
// module chunks = 